import { memo, ReactNode } from 'react'
import cn from 'classnames'

import s from './List.module.less'

interface IProps {
  children?: ReactNode
  className?: string
  testId?: string
}

export const List = memo<IProps>(function List({ children, className, testId }) {
  return (
    <div className={cn(s.List, className)} data-name="table" data-test-id={testId}>
      {children}
    </div>
  )
})
